module.exports = __webpack_public_path__ + "static/media/croseicon.fc40e6cd.svg";